import { useCallback, useEffect, useRef, useState } from 'react'

export const useDebouncedWidth = () => {
  const [innerContainerWidth, setInnerContainerWidth] = useState(0)
  const timeoutRef = useRef<ReturnType<typeof setTimeout>>(null)

  // onLayout can report several different widths before the layout settles.
  // Debounce the update to prevent the auto-scroll effect from running with intermediate values.
  const debouncedSetWidth = useCallback((containerWidth: number) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current)
    }

    const nextTimeout = setTimeout(() => {
      setInnerContainerWidth(containerWidth)
      timeoutRef.current = null
    }, 1000)

    timeoutRef.current = nextTimeout
  }, [])

  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current)
        timeoutRef.current = null
      }
    }
  }, [])

  return { debouncedSetWidth, innerContainerWidth }
}
